////    CORE    ////
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AppRoutingModule } from 'src/app/app-routing.module'

////    MODULES    ////
import { IconModule } from '@helvetia/components'
import { SidebarComponent } from './sidebar.component'
import { MenuItems } from 'src/app/shared/menu-items/menu-items'
import { MaterialImporterModule } from 'src/app/shared/material-importer/material-importer.module'

////    COMPONENTS    ////

@NgModule({
  declarations: [SidebarComponent],
  imports: [CommonModule, AppRoutingModule, IconModule, MaterialImporterModule],
  exports: [SidebarComponent],
  providers: [ MenuItems  ]
})
export class SidebarModule {}
